interface FormatContext {
  userName?: string;
  leagueName?: string;
}

const ACTION_LABELS: Record<string, (d: Record<string, unknown> | null, ctx: FormatContext) => string> = {
  'autopick.assigned': (d, ctx) => {
    const who = ctx.userName ? `${ctx.userName} — ` : '';
    return `${who}Autopick: ${d?.team ?? 'unknown'} for MD${d?.matchday ?? '?'}`;
  },
  'admin.pick_overridden': (d, ctx) => {
    const who = ctx.userName || (d?.display_name as string) || 'member';
    return `Pick override: ${who} → ${d?.team ?? '?'} MD${d?.matchday ?? '?'}`;
  },
  'invite.sent': (d, ctx) => {
    const league = ctx.leagueName ? ` (${ctx.leagueName})` : '';
    return `Invite sent to ${d?.inviteeEmail ?? 'member'}${league}`;
  },
  'league.created': (d) => `League created: ${d?.name ?? 'unknown'}`,
  'notification.picks_open': (d, ctx) => {
    const league = ctx.leagueName ? `${ctx.leagueName} — ` : '';
    return `${league}Picks open for MD${d?.nextMatchday ?? d?.matchday ?? '?'}`;
  },
  'pick.submitted': (d, ctx) => {
    const who = ctx.userName || (d?.display_name as string) || 'Member';
    const team = d?.team ? ` — ${d.team}` : '';
    const dd = d?.doubleDown ? ' (DD)' : '';
    return `${who} MD${d?.matchday ?? '?'}${team}${dd}`;
  },
  'auth.magic_link_sent': (d) => `Magic link sent to ${d?.targetEmail ?? d?.email ?? 'user'}`,
  'sync.fixtures_completed': (d) => {
    const count = d?.fixturesUpdated ?? d?.fixtures_updated;
    return `Fixture sync completed${count ? ` — ${count} fixtures` : ''}`;
  },
};

export function formatAuditAction(
  action: string,
  details: Record<string, unknown> | null,
  context?: FormatContext,
): string {
  const ctx = context ?? {};
  const formatter = ACTION_LABELS[action];
  if (formatter) return formatter(details, ctx);
  return action.split('.').pop()?.replace(/_/g, ' ') ?? action;
}
